import React from "react";

const Delete = (props) => (
  <svg
    width="512"
    height="512"
    enableBackground="new 0 0 510 510"
    viewBox="0 0 510 510"
    xmlnsXlink="http://www.w3.org/2000/svg"
    {...props}
    className="svg"
  >
    <path d="m118.83 467.24c1.193 24.006 20.863 42.757 44.944 42.757h182.45c24.081 0 43.753-18.75 44.944-42.757l26.28-302.24h-324.9zm181.17-227.24h30v165h-30zm-60 0h30v165h-30zm-60 0h30v165h-30z" />
    <path d="m330 75v-30c0-24.812-20.186-45-45-45h-60c-24.812 0-45 20.188-45 45v30h-120v60h390v-60zm-120 0v-30c0-8.271 6.73-15 15-15h60c8.272 0 15 6.729 15 15v30z" />
  </svg>
);

const Edit = (props) => (
  <svg
    enableBackground="new 0 0 383.947 383.947"
    version="1.1"
    viewBox="0 0 383.95 383.95"
    xmlSpace="preserve"
    xmlnsXlink="http://www.w3.org/2000/svg"
    {...props}
    className="svg"
  >
    <polygon points="0 303.95 0 383.95 80 383.95 316.05 147.89 236.05 67.893" />
    <path d="m377.71 56.053-49.814-49.813c-8.32-8.32-21.867-8.32-30.187 0l-39.04 39.04 80 80 39.04-39.04c8.321-8.32 8.321-21.867 1e-3 -30.187z" />
  </svg>
);

const Check = (props) => (
  <svg
    width="512"
    height="512"
    enableBackground="new 0 0 515.556 515.556"
    viewBox="0 0 515.56 515.56"
    xmlnsXlink="http://www.w3.org/2000/svg"
    {...props}
    className="svg"
  >
    <path d="m0 274.23 176.55 176.89 339.01-338.67-48.67-47.997-290.34 290-128.55-128.55z" />
  </svg>
);

const ArrowUp = (props) => (
  <svg
    enableBackground="new 0 0 292.362 292.362"
    version="1.1"
    viewBox="0 0 292.36 292.36"
    xmlSpace="preserve"
    xmlnsXlink="http://www.w3.org/2000/svg"
    {...props}
    className="svg"
  >
    <path d="m286.94 197.29-127.91-127.91c-3.613-3.617-7.895-5.424-12.847-5.424s-9.233 1.807-12.85 5.424l-127.91 127.91c-3.617 3.614-5.424 7.898-5.424 12.846s1.807 9.233 5.424 12.847c3.621 3.617 7.902 5.428 12.85 5.428h255.81c4.949 0 9.233-1.811 12.848-5.428 3.613-3.613 5.427-7.898 5.427-12.847s-1.814-9.232-5.427-12.846z" />
  </svg>
);

const ArrowDown = (props) => (
  <svg
    enableBackground="new 0 0 292.362 292.362"
    version="1.1"
    viewBox="0 0 292.36 292.36"
    xmlSpace="preserve"
    xmlnsXlink="http://www.w3.org/2000/svg"
    {...props}
    className="svg"
  >
    <path d="m286.94 69.377c-3.614-3.617-7.898-5.424-12.848-5.424h-255.81c-4.952 0-9.233 1.807-12.85 5.424-3.617 3.621-5.424 7.902-5.424 12.851 0 4.948 1.807 9.229 5.424 12.847l127.91 127.91c3.621 3.617 7.902 5.428 12.85 5.428s9.233-1.811 12.847-5.428l127.91-127.91c3.613-3.617 5.427-7.898 5.427-12.847 0-4.948-1.814-9.229-5.427-12.85z" />
  </svg>
);

const Close = (props) => (
  <svg
    width="329pt"
    height="329pt"
    viewBox="0 0 329.27 329"
    xmlnsXlink="http://www.w3.org/2000/svg"
    {...props}
    className="svg"
  >
    <path d="m194.8 164.77 128.21-128.21c8.3438-8.3398 8.3438-21.824 0-30.164-8.3398-8.3398-21.824-8.3398-30.164 0l-128.21 128.21-128.21-128.21c-8.3438-8.3398-21.824-8.3398-30.164 0-8.3438 8.3398-8.3438 21.824 0 30.164l128.21 128.21-128.21 128.21c-8.3438 8.3398-8.3438 21.824 0 30.164 4.1562 4.1602 9.6211 6.25 15.082 6.25 5.4609 0 10.922-2.0898 15.082-6.25l128.21-128.21 128.21 128.21c4.1602 4.1602 9.6211 6.25 15.082 6.25 5.4609 0 10.922-2.0898 15.082-6.25 8.3438-8.3398 8.3438-21.824 0-30.164z" />
  </svg>
);

const Spinner = (props) => (
  <svg
    version="1.1"
    viewBox="0 0 16 16"
    xmlnsXlink="http://www.w3.org/2000/svg"
    {...props}
    className="svg"
  >
    <path d="m12.9 3.1c1.3 1.2 2.1 3 2.1 4.9 0 3.9-3.1 7-7 7s-7-3.1-7-7c0-1.9 0.8-3.7 2.1-4.9l-0.8-0.8c-1.4 1.5-2.3 3.5-2.3 5.7 0 4.4 3.6 8 8 8s8-3.6 8-8c0-2.2-0.9-4.2-2.3-5.7l-0.8 0.8z" />
  </svg>
);

const Plus = (props) => (
  <svg
    width="426.67pt"
    height="426.67pt"
    viewBox="0 0 426.67 426.67"
    xmlnsXlink="http://www.w3.org/2000/svg"
    {...props}
    className="svg"
  >
    <path d="m405.33 192h-170.66v-170.67c0-11.773-9.5586-21.332-21.336-21.332-11.773 0-21.332 9.5586-21.332 21.332v170.67h-170.67c-11.773 0-21.332 9.5586-21.332 21.332 0 11.777 9.5586 21.336 21.332 21.336h170.67v170.66c0 11.777 9.5586 21.336 21.332 21.336 11.777 0 21.336-9.5586 21.336-21.336v-170.66h170.66c11.777 0 21.336-9.5586 21.336-21.336 0-11.773-9.5586-21.332-21.336-21.332z" />
  </svg>
);

const ICONS = {
  Delete,
  Edit,
  ArrowDown,
  ArrowUp,
  Spinner,
  Close,
  Check,
  Plus,
};

export default ICONS;
